import { MessageCircle, Phone } from "lucide-react";
import Reveal from "@/components/Reveal";
import LogoMark from "@/components/LogoMark";
import { waLink, SITE } from "@/data/site";

function WhatsAppIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm5.8 14.03c-.24.68-1.42 1.3-1.96 1.35-.5.05-1.13.24-3.8-.8-3.2-1.26-5.23-4.53-5.39-4.74-.15-.21-1.28-1.71-1.28-3.26 0-1.55.81-2.31 1.1-2.63.29-.31.63-.39.85-.39.21 0 .43 0 .62.01.2.01.46-.08.72.55.26.63.9 2.16.97 2.32.08.16.13.34.02.55-.1.21-.16.34-.31.52-.16.18-.33.4-.47.54-.16.16-.32.33-.14.64.18.31.8 1.32 1.72 2.14 1.18 1.05 2.18 1.38 2.49 1.53.31.16.5.13.68-.08.18-.21.79-.92 1-1.24.21-.31.42-.26.7-.16.29.1 1.82.86 2.13 1.02.31.16.52.23.6.36.07.13.07.76-.17 1.45Z" />
    </svg>
  );
}

export default function Contact() {
  return (
    <section
      id="kontakt"
      className="relative scroll-mt-24 overflow-hidden border-t border-gold/10 py-28 md:py-40"
      data-testid="contact-section"
    >
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[40rem] w-[40rem] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-15 blur-[130px]"
        style={{ background: "radial-gradient(circle, #D4AF37 0%, transparent 65%)" }}
      />
      <div className="pointer-events-none absolute -bottom-16 -left-16 opacity-[0.06]" aria-hidden="true">
        <LogoMark className="h-72 w-72 animate-spin-slow" />
      </div>

      <div className="relative mx-auto max-w-3xl px-5 text-center md:px-10">
        <Reveal>
          <p className="font-gurmukhi text-2xl text-gold">ਸਤ ਸ੍ਰੀ ਅਕਾਲ</p>
          <h2 className="mt-6 font-serif text-5xl font-light tracking-[-0.02em] text-cream md:text-7xl">
            Lass uns <em className="text-goldgrad">sprechen</em>
          </h2>
          <p className="mx-auto mt-6 max-w-md text-base font-light leading-relaxed text-rosy md:text-lg">
            Schreibe uns direkt für individuelle Anfertigungen oder Beratung —
            auf Deutsch, Englisch oder Punjabi.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp"
              className="flex w-full items-center justify-center gap-3 rounded-full bg-wa px-9 py-4 text-sm font-medium uppercase tracking-widest text-white transition-transform duration-300 hover:scale-[1.03] active:scale-[0.98] sm:w-auto"
            >
              <WhatsAppIcon className="h-5 w-5" />
              WhatsApp schreiben
            </a>
            <a
              href={SITE.phoneHref}
              data-testid="contact-phone"
              className="flex w-full items-center justify-center gap-3 rounded-full border border-gold px-9 py-4 text-sm font-medium uppercase tracking-widest text-gold transition-colors duration-300 hover:bg-gold hover:text-wine sm:w-auto"
            >
              <Phone className="h-4 w-4" />
              {SITE.phoneDisplay}
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.35}>
          <p className="mt-10 text-xs font-light uppercase tracking-[0.25em] text-cream/50">
            Jede Nachricht wird persönlich beantwortet
          </p>
        </Reveal>
      </div>
    </section>
  );
}
